import gql from "graphql-tag";

export const START_BACKLOG_ACTIVITY = gql`
  mutation startBacklogActivity($input: startBacklogActivityInput) {
    startBacklogActivity(input: $input) {
      _id
      title
      description
      timebox
      created_by {
        _id
        email
        full_name
      }
      project {
        _id
        title
        color
      }
      activity_type
      meta
      time {
        start
        paused {
          created_at
          time
          continue
        }
      }
    }
  }
`;
